import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InvestormenuModule} from '../../../investormenu/investormenu.module';
import {HorizontalLoaderModule} from '../../../horizontal-loader/horizontal-loader.module';
import {CommonSectionsModule} from '../../common/common-sections.module';
import {
    MatExpansionModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule
} from '@angular/material';
import {IndianCurrencyFormatterModule} from '../../common/indian-currency-formatter/indian-currency-formatter.module';
import {InvestmentsRoutingModule} from './investments.routing.module';
import {InvestmentsComponent} from './investments.component';
import {TooltipModule} from '../../../tooltip/tooltip.module';
import {DoughnutModule} from '../../../doughnut/doughnut.module';
import { ShowTurnOffSwiftPopupUtil } from '../../../utils/finzy-flex/show-turn-off-swift-popup.utils';

@NgModule({
    declarations: [InvestmentsComponent],
    imports: [
        InvestmentsRoutingModule,
        HorizontalLoaderModule,
        CommonModule,
        CommonSectionsModule,
        InvestormenuModule,
        MatProgressSpinnerModule,
        MatTableModule,
        IndianCurrencyFormatterModule,
        MatPaginatorModule,
        TooltipModule,
        DoughnutModule,
        MatTabsModule,
        MatExpansionModule,
        MatToolbarModule
    ],
    providers: [
        ShowTurnOffSwiftPopupUtil
    ]
})
export class InvestmentsModule {
}
